import { AdyenPaymentMethodType } from "@faire/retailer-visitor-shared/components/AddPaymentMethods/consts";
import { lazyIcons } from "@faire/retailer-visitor-shared/components/PaymentMethodIcons/icons";
import { getSettingAdyenEUPaymentMethodsIcons } from "@faire/retailer-visitor-shared/settings/getSettingAdyenEUPaymentMethodsIcons";
import { Row } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { CardBrand } from "@faire/web-api--source/indigofair/data/CardBrand";
import { IInstrumentLink } from "@faire/web-api--source/indigofair/data/IInstrumentLink";
import { IInstrumentTypeEnum } from "@faire/web-api--source/indigofair/data/IInstrumentTypeEnum";
import React, { Suspense } from "react";

import InstrumentType = IInstrumentTypeEnum.InstrumentType;

const DEFAULT_ICON_SIZE = "28px";

export const mapInstrumentToPaymentMethod = (instrument: IInstrumentLink) => {
  if (instrument.type === InstrumentType.FAIRE_PAY) {
    return "fairepay";
  }

  if (instrument.card) {
    switch (instrument.card.brand) {
      case CardBrand.CARTES_BANCAIRES:
        return "cartebancaire";
      case CardBrand.MASTERCARD:
        return "mc";
      case CardBrand.AMERICAN_EXPRESS:
        return "amex";
      case CardBrand.DINERS_CLUB:
        return "diners";
      case CardBrand.VISA:
      case CardBrand.DISCOVER:
        return instrument.card.brand.toLowerCase();
    }
  } else if (instrument.bank_account) {
    switch (instrument.type) {
      case InstrumentType.SEPA:
        return AdyenPaymentMethodType.SEPA;
      case InstrumentType.SOFORT:
        return AdyenPaymentMethodType.SOFORT;
      case InstrumentType.IDEAL:
        return AdyenPaymentMethodType.IDEAL;
      case InstrumentType.BACS:
        return AdyenPaymentMethodType.BACS;
      default:
        return "ach";
    }
  }
  return "";
};

export const mapInstrumentToIcon = (
  instrument: IInstrumentLink,
  iconSize?: string,
  square?: boolean,
  monochrome?: boolean
) => {
  const paymentMethod = mapInstrumentToPaymentMethod(instrument);
  return mapToPaymentMethodIcon(paymentMethod, iconSize, square, monochrome);
};

// TODO: refactor so we pass the payment instrument into this function rather than using this dict here
const paymentIdToName = (id: string): string => {
  if (id === "mc") {
    return "Master Card";
  }
  return id;
};

export const mapToPaymentMethodIcon = (
  paymentMethod: string,
  iconSize?: string,
  square?: boolean,
  monochrome?: boolean
): React.ReactNode => {
  iconSize = iconSize ?? DEFAULT_ICON_SIZE;

  // @ts-expect-error FIXME(implicitAny): https://faire.link/no-implicit-any
  const PaymentMethodsIcon = lazyIcons[paymentMethod];

  return PaymentMethodsIcon ? (
    <Suspense fallback={null}>
      <div
        aria-label={paymentIdToName(paymentMethod)}
        role="region"
        tabIndex={0}
      >
        <PaymentMethodsIcon
          key={paymentMethod}
          fontSize={iconSize}
          square={square}
          monochrome={monochrome}
          data-test-id={"payment-method-icon-" + paymentMethod}
        />
      </div>
    </Suspense>
  ) : null;
};

export const PaymentMethodIcons: React.FC = () => (
  <Row>
    {getSettingAdyenEUPaymentMethodsIcons().map(
      (paymentMethod: string, i: number) => (
        <React.Fragment key={paymentMethod}>
          {i !== 0 ? <Spacer width="1x" /> : null}
          {mapToPaymentMethodIcon(paymentMethod)}
        </React.Fragment>
      )
    )}
  </Row>
);
